var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 21,
    viewBox: "0 0 32 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4857 6.18321C25.451 2.70047 22.163 0.155273 18.2661 0.155273C15.3283 0.155273 12.7361 1.60184 11.1947 3.81011C10.4091 3.18207 9.40695 2.80483 8.31319 2.80483C5.79928 2.80483 3.76057 4.79705 3.76057 7.25436C3.76057 7.66998 3.81976 8.07101 3.92856 8.45371C1.61398 9.46262 0 11.7314 0 14.3681C0 17.9442 2.96448 20.8446 6.62188 20.8446H13.239V15.1408H9.64164L15.6374 8.24487L21.6312 15.1408H18.0349V20.8446H23.4754C27.7835 20.8446 31.275 17.4296 31.275 13.2182C31.275 10.0485 29.2994 7.33311 26.4857 6.18321Z",
    fill: "#2054D2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.7b791b1704e1d50e5f0d172e1655661f.svg";
export { ForwardRef as ReactComponent };